import React from "react";
import { useNavigate } from "react-router";
import { AddLocalStorageData, GetLocalStorageData, isStringEmpty } from "../Helpers/Utilities";

const SaveAndNavigate = (props) => {
  const navigate = useNavigate();

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);

  const eligibilityCriteriaLocked = patientData.eligibilityCriteriaLocked ?? false;
  const locked = patientData?.locked ?? false;
  const part2Locked = patientData?.part2locked ?? false;

  let isEligible = GetLocalStorageData("isEligible");

  const part2Pages = [
    "/NonMDETreatment",
    "/RenalLabAssessment",
    "/OtherLabAssessment",
    "/MMARelatedComplications",
    "/NutritionManagement"
  ];

  // Determine button visibility
  const currPage = props.paths.currPage;
  let shouldShowSaveButtons = false;
  let shouldShowValidateButtons = false;

  if (!locked && eligibilityCriteriaLocked) {
    // Rule 1: both false → show everywhere
    shouldShowSaveButtons = true;
      shouldShowValidateButtons = true;
  } else if (locked && eligibilityCriteriaLocked && !part2Locked) {
    // Rule 2: locked true → show only for part2 pages
    shouldShowSaveButtons = part2Pages.includes(currPage);
    shouldShowValidateButtons =  part2Pages.includes(currPage);
  } else if (!eligibilityCriteriaLocked) {
    // Rule 3: part2Locked true → show for none
    shouldShowSaveButtons = false;
    shouldShowValidateButtons = true;
  }

  // Handlers
  const HandlePreviousClick = async () => {
    const eligibilityCriteriaTab = ["/EligibilityCriteria"];
    
    if (props.paths.prevPage === "/PatientScreening") {
      navigate(props.paths.prevPage);
    } else if (
      (!eligibilityCriteriaLocked && !isStringEmpty(currPage) && eligibilityCriteriaTab.includes(currPage.toLowerCase())) ||
      await props.Save(true)
    ) {
      navigate(props.paths.prevPage);
    }
    window.scrollTo(0, 0);
  };

  const HandleNextClick = async () => {
    const eligibilityCriteriaTab = ["/EligibilityCriteria"];
    if (isEligible && currPage === "/EligibilityCriteria") {
      navigate(props.paths.nextPage);
    } else if (
      (!eligibilityCriteriaLocked && !isStringEmpty(currPage) && eligibilityCriteriaTab.includes(currPage.toLowerCase())) ||
      await props.Save(true)
    ) {
      navigate(props.paths.nextPage);
    }
    window.scrollTo(0, 0);
  };

  const HandleSaveClick = async () => {
    part2Locked || await props.Save(false);
    window.scrollTo(0, 0);
    AddLocalStorageData("loadConfig", true);
  };

  const HandleSubmitClick = async () => {
    part2Locked || await props.Save(true);
    window.scrollTo(0, 0);
    AddLocalStorageData("loadConfig", true);
  };

  return (
    <>
      {props.paths.prevPage && (
        <span className="pointer-class" onClick={HandlePreviousClick}>
          <img className="previous-btn-padding" src="../Assets/images/previous.png" alt="" />
        </span>
      )}

      {shouldShowSaveButtons &&
        currPage !== "/PatientScreening" &&
        currPage !== "/AbbreviationList" &&
        currPage !== "/EligibilityCriteria" &&
        currPage !== "/MDEInfo" && (
          <span
            className="btn save-btn"
            onClick={HandleSaveClick}
            style={{ fontWeight: "600", fontSize: "large", marginRight: "20px" }}
          >
            Save
          </span>
        )}

      {shouldShowValidateButtons &&
        currPage !== "/PatientScreening" &&
        currPage !== "/AbbreviationList" &&
        currPage !== "/MDEInfo" &&
        (!eligibilityCriteriaLocked || (
            eligibilityCriteriaLocked &&
            !isStringEmpty(props.paths.currPage) &&
            !["/EligibilityCriteria"].includes(props.paths.currPage)))
          &&  (
          <span
            className="btn save-btn"
            onClick={HandleSubmitClick}
            style={{ fontWeight: "600", fontSize: "large" }}
          >
            Validate
          </span>
        )}

      {props.paths.nextPage && (
        <span className="pointer-class" onClick={HandleNextClick}>
          <img className="next-btn-padding" src="../Assets/images/next.png" alt="" />
        </span>
      )}
    </>
  );
};

export default SaveAndNavigate;
